// src/components/subscription/SubscriptionPlans.jsx

import React, { useState } from 'react';
import { useSubscription } from '../../context/SubscriptionContext';
import PaymentModal from './PaymentModal';

export default function SubscriptionPlans({ onClose }) {
  const { plans, getCurrentPlan, updateSubscription } = useSubscription();
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showPayment, setShowPayment] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const currentPlan = getCurrentPlan();

  const handleSelectPlan = async (planId) => {
    if (planId === 'free') {
      setLoading(true);
      try {
        const success = await updateSubscription('free');
        if (success) {
          alert('Ücretsiz plana geçiş yapıldı!');
          onClose && onClose();
        } else {
          alert('Bir hata oluştu. Lütfen tekrar deneyin.');
        }
      } catch (error) {
        console.error('Plan update error:', error);
        alert('Bir hata oluştu. Lütfen tekrar deneyin.');
      }
      setLoading(false);
    } else {
      setSelectedPlan(planId);
      setShowPayment(true);
    }
  };

  const handlePaymentSuccess = async (paymentData) => {
    setLoading(true);
    try {
      const success = await updateSubscription(selectedPlan, paymentData);
      if (success) {
        alert('Abonelik başarıyla güncellendi!');
        setShowPayment(false);
        onClose && onClose();
      } else {
        alert('Bir hata oluştu. Lütfen tekrar deneyin.');
      }
    } catch (error) {
      console.error('Subscription update error:', error);
      alert('Bir hata oluştu. Lütfen tekrar deneyin.');
    }
    setLoading(false);
  };

  if (showPayment) {
    return (
      <PaymentModal
        plan={plans[selectedPlan.toUpperCase()]}
        onSuccess={handlePaymentSuccess}
        onClose={() => setShowPayment(false)}
      />
    );
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '40px',
        maxWidth: '1000px',
        width: '90%',
        maxHeight: '90%',
        overflow: 'auto'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
          <h2 style={{ margin: 0, color: '#333' }}>Abonelik Planları</h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#666'
            }}
          >
            ×
          </button>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '24px',
          marginBottom: '30px'
        }}>
          {Object.values(plans).map((plan) => {
            const isCurrentPlan = currentPlan.id === plan.id;
            const isUpgrade = plans[currentPlan.id.toUpperCase()] && 
                            Object.keys(plans).indexOf(plan.id.toUpperCase()) > 
                            Object.keys(plans).indexOf(currentPlan.id.toUpperCase());

            return (
              <div
                key={plan.id}
                style={{
                  border: isCurrentPlan ? '3px solid #06C167' : '1px solid #e9ecef',
                  borderRadius: '12px',
                  padding: '24px',
                  textAlign: 'center',
                  position: 'relative',
                  backgroundColor: isCurrentPlan ? '#f8f9ff' : 'white'
                }}
              >
                {isCurrentPlan && (
                  <div style={{
                    position: 'absolute',
                    top: '-12px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: '#06C167',
                    color: 'white',
                    padding: '4px 16px',
                    borderRadius: '12px',
                    fontSize: '12px',
                    fontWeight: 'bold'
                  }}>
                    Mevcut Plan
                  </div>
                )}

                <h3 style={{ color: '#333', marginBottom: '8px' }}>{plan.name}</h3>
                
                <div style={{ marginBottom: '16px' }}>
                  <span style={{ fontSize: '32px', fontWeight: 'bold', color: '#06C167' }}>
                    {plan.price === 0 ? 'Ücretsiz' : `${plan.price}₺`}
                  </span>
                  {plan.price > 0 && <span style={{ color: '#666' }}>/ay</span>}
                </div>

                <ul style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: '0 0 24px 0',
                  textAlign: 'left'
                }}>
                  {plan.features.map((feature, index) => (
                    <li key={index} style={{
                      padding: '8px 0',
                      borderBottom: '1px solid #f1f3f4',
                      display: 'flex',
                      alignItems: 'center'
                    }}>
                      <span style={{ color: '#28a745', marginRight: '8px' }}>✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>

                <button
                  onClick={() => handleSelectPlan(plan.id)}
                  disabled={loading || isCurrentPlan}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: 'none',
                    borderRadius: '6px',
                    fontWeight: 'bold',
                    cursor: isCurrentPlan ? 'default' : 'pointer',
                    backgroundColor: isCurrentPlan 
                      ? '#6c757d' 
                      : isUpgrade 
                        ? '#28a745' 
                        : '#06C167',
                    color: 'white',
                    opacity: loading ? 0.7 : 1
                  }}
                >
                  {loading 
                    ? 'İşleniyor...' 
                    : isCurrentPlan 
                      ? 'Mevcut Plan' 
                      : plan.price === 0 
                        ? 'Ücretsiz Plana Geç'
                        : isUpgrade 
                          ? 'Yükselt'
                          : 'Seç'
                  }
                </button>
              </div>
            );
          })}
        </div>

        <div style={{
          textAlign: 'center',
          color: '#666',
          fontSize: '14px'
        }}>
          <p>• Tüm planlar aylık faturalandırılır</p>
          <p>• İstediğiniz zaman iptal edebilirsiniz</p>
          <p>• 7 gün para iade garantisi</p>
        </div>
      </div>
    </div>
  );
}